import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { useState as _, useEffect as g } from "react";
import { GradientButton as d } from "../GradientButton/GradientButton.js";
import { Button as c } from "../Button/Button.js";
import '../../assets/TabNavigation.css';const r = {
  "tab-navigation__list": "_tab-navigation__list_146qs_6",
  "tab-navigation__right-side": "_tab-navigation__right-side_146qs_16"
};
function h({
  tabs: i = [],
  onTabChanged: l = () => !0,
  rightSideContent: a
}) {
  const [n, b] = _(i[0]), u = (t) => {
    const o = document.querySelector("basic-grid-module");
    o == null || o.setAttribute("first-entry", !0), o == null || o.setAttribute("data-state", "entering"), t.button.label !== n.button.label && b(t);
  };
  return g(() => l(n), [n, l]), /* @__PURE__ */ s("tab-navigation", { children: [
    /* @__PURE__ */ e("ul", { className: [r["tab-navigation__list"], "tab-navigation__list"].join(" "), children: i.length > 0 && i.map((t) => n.button.label === t.button.label ? /* @__PURE__ */ e(
      "li",
      {
        className: [r["tab-navigation__item"], "tab-navigation__item"].join(" "),
        style: {
          "--gradient-start-color": t.button.gradientStartColor,
          "--gradient-end-color": t.button.gradientEndColor
        },
        children: /* @__PURE__ */ e(
          d,
          {
            onClick: () => {
              u(t);
            },
            label: t.button.label,
            disabled: !0
          }
        )
      },
      `tab-item-${t.button.label}`
    ) : /* @__PURE__ */ e(
      "li",
      {
        className: [r["tab-navigation__item"], "tab-navigation__item"].join(" "),
        children: /* @__PURE__ */ e(
          c,
          {
            onClick: () => {
              u(t);
            },
            label: t.button.label,
            customColors: {
              bgColor: t.button.buttonBgColor,
              bgHoverColor: t.button.buttonHoverBgColor,
              color: t.button.buttonTextColor,
              hoverColor: t.buttonHoverTextColor,
              borderColor: t.button.buttonTextColor,
              borderHoverColor: t.button.borderHoverColor ?? t.button.buttonHoverBgColor
            }
          }
        )
      },
      `tab-item-${t.button.label}`
    )) }),
    /* @__PURE__ */ e("div", { className: r["tab-navigation__right-side"], children: a !== void 0 && a })
  ] });
}
export {
  h as TabNavigation,
  h as default
};
